<template>
  <div class="ai-ask-user">
    <div class="ask-title">Ассистент уточняет:</div>
    <div v-for="q in questions" :key="q.id" class="ask-question">
      <div class="ask-text">{{ q.text }}<span v-if="q.optional" class="ask-optional"> (необязательно)</span></div>
      <div class="ask-options">
        <template v-if="q.mode === 'multi'">
          <span v-for="opt in (q.options || [])" :key="opt.value" class="ask-opt">
            ☐ {{ opt.label }}
          </span>
        </template>
        <template v-else>
          <span v-for="opt in (q.options || [])" :key="opt.value" class="ask-opt">
            ○ {{ opt.label }}
          </span>
        </template>
      </div>
    </div>
    <div v-if="answersText" class="ask-answers">
      <div class="ask-answers-title">Ответ:</div>
      <div class="ask-answers-text">{{ answersText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiAskUserBlock',
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    questions() {
      return this.block.questions || [];
    },
    answersText() {
      return this.block.answers || null;
    },
  },
};
</script>

<style scoped>
.ai-ask-user {
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
}

.ask-title {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.ask-question {
  margin-bottom: 8px;
}

.ask-text {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.ask-optional {
  font-weight: 400;
  color: #9ca3af;
  font-size: 12px;
}

.ask-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 4px;
}

.ask-opt {
  font-size: 13px;
  color: #4b5563;
}

.ask-answers {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #f3f4f6;
}

.ask-answers-title {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
}

.ask-answers-text {
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
